export default "__VITE_ASSET__CLmK$tpc__"